import { ISupportInfo } from "types/Chat";

/**
 * CLE-3043 — the staff chat widget's display name, as product settled it: change it here and only here.
 * The chat type behind it is still `ContractManagementBot`.
 */
export const HOSPITAL_STAFF_BOT_NAME = "Hospital Staff Bot";

/**
 * What hospital staff see in the widget's header (2026-10-29, Ani after the demo: "Clear Health AI",
 * like the patient widget). Admin pages and Slack keep calling it HOSPITAL_STAFF_BOT_NAME.
 */
export const STAFF_WIDGET_TITLE = "Clear Health AI";

export const STAFF_WIDGET_SUBTITLE = "Your assistant for any questions";

/**
 * The staff widget's greeting before the first message, with the user's first name — the first
 * whitespace-separated word of their full name (`userSlice.name`). No name → "Hi! 👋 …".
 */
export const buildStaffGreeting = (
  fullName: string | null | undefined
): string => {
  const firstName = (fullName ?? "").trim().split(/\s+/)[0];
  const hello = firstName ? `Hi ${firstName}!` : "Hi!";
  return `${hello} 👋 I'm your Clear Health AI Assistant. I can help you navigate the platform, answer questions, and guide you through everyday tasks. What can I help you with today?`;
};

export const CONTACT_SUPPORT_LABEL = "Contact Clear Health support";

/** How often the open widget re-reads a chat while Clear Health support is involved. */
export const SUPPORT_POLL_INTERVAL_MS = 4000;

/**
 * Used only when the API has not sent its own `support` block (an escalation that failed before any
 * answer). The live values come from GET /chats/assigned-model.
 */
export const SUPPORT_CONTACT_FALLBACK: Pick<ISupportInfo, "email" | "phone"> = {
  email: "support@clearhealthinc.com",
  phone: "888-918-2522",
};
